function addActiveCampaignScriptTag() {
  const acEventActid = import.meta.env.VITE_ACTIVE_CAMPAIGN_EVENT_ACTID
  if (acEventActid == null) return

  const script = document.createElement('script')
  script.innerHTML = `
		(function(e,t,o,n,p,r,i){e.visitorGlobalObjectAlias=n;e[e.visitorGlobalObjectAlias]=e[e.visitorGlobalObjectAlias]||function(){(e[e.visitorGlobalObjectAlias].q=e[e.visitorGlobalObjectAlias].q||[]).push(arguments)};e[e.visitorGlobalObjectAlias].l=(new Date).getTime();r=t.createElement("script");r.src=o;r.async=true;i=t.getElementsByTagName("script")[0];i.parentNode.insertBefore(r,i)})(window,document,"https://diffuser-cdn.app-us1.com/diffuser/diffuser.js","vgo");
		vgo('setAccount', '${acEventActid}');
		vgo('setTrackByDefault', true);
		vgo('process');
	`
  document.body.appendChild(script)
}

type WindowWithVgo = Window &
  typeof globalThis & {
    vgo: (action: string, param?: string | boolean) => void | undefined
  }

function setLoggedUserEmailToACVisitor(userEmail: string) {
  // existuje window object
  if (typeof window === 'undefined') return

  // existuje vgo function? - existuje len ako je mountnuty active campaign tracking script - inac nema vyznam pokracovat
  const { vgo } = window as WindowWithVgo
  if (typeof vgo === 'undefined') {
    console.log('vgo is undefined')
    return
  }

  // zavolaj "setEmail" vgo akciu pre current visitora v cookie w userEmail-om a potom aj "process"
  vgo('setEmail', userEmail)
  vgo('process')
}

export { addActiveCampaignScriptTag, setLoggedUserEmailToACVisitor }
